<template>
  <section class="form-presentation">
    <FormContainer
      v-for="userInput in formData"
      :key="`presentation-form-value-${userInput.id}`"
      row
      class="form-presentation__container"
    >
      <FormLabel
        :id="`presentation-form-value-${userInput.id}`"
        :label-text="userInput.label"
        class="form-presentation__label"
      />
      <div
        :id="`presentation-form-value-${userInput.id}`"
        class="form-presentation__input"
        :class="{
          'form-presentation__input--italic':
            !userInput.value ||
            userInput.value === 'None' ||
            userInput.value === -1,
        }"
      >
        {{ getInputDisplayValue(userInput) }}
      </div>
    </FormContainer>
    <FormError v-if="errorMessage" :error-message="errorMessage" />
  </section>
</template>

<script>
  import FormContainer from './FormContainer.vue';
  import FormError from './FormError.vue';
  import FormLabel from './FormLabel.vue';

  export default {
    name: 'FormPresentation',
    components: {
      FormContainer,
      FormError,
      FormLabel,
    },
    props: {
      formData: {
        type: Array,
        required: true,
      },
      errorMessage: {
        type: String,
        required: false,
        default: '',
      },
    },
    methods: {
      formatPhoneNumber(phoneNumber) {
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
      },
      getInputDisplayValue(userInput) {
        if (userInput.id === 'phone')
          return this.formatPhoneNumber(userInput.value);
        if (
          !userInput.value ||
          userInput.value === 'None' ||
          userInput.value === -1
        )
          return 'None selected';

        return userInput.value;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-presentation {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 26px 75px;
    width: 100%;
    max-width: 1000px;
    background-color: #dbdcde;
    border-radius: 6px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    &__container {
      width: 100%;
    }
    &__label {
      width: 33.3% !important;
      align-items: flex-start !important;
      font-weight: 700 !important;
      font-size: 16px !important;
    }
    &__input {
      width: 66.7%;
      padding: 2px 8px;
      font-weight: 700;
      color: var(--itr-grey-disabled-text);
      height: fit-content;
      min-height: 30px;

      background: #fff;
      border: 1px solid #a7a9ab;
      border-radius: 4px;
      color: #a7a9ab;
      font-size: 16px;
      font-family: 'Open Sans', sans-serif;
      line-height: 24px;
      transition:
        color 0.33s,
        border-color 0.33s;

      &--italic {
        font-style: italic;
      }
    }
  }
</style>
